export default __webpack_public_path__ + "static/media/video5.a943b0bd.mp4";